import { useState } from 'react';

import { Dustbin } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
} from '@randstad-lean-mobile-factory/react-components-core';

import { useDeleteRoutingById } from '../../../Hooks/Routings/useDeleteRoutingById';

import { DeleteRoutingsModalProps } from './DeleteRoutingsModal.types';

const DeleteRoutingModalComponent = ({ routingId }: DeleteRoutingsModalProps) => {
  const [open, setOpen] = useState(false);
  const deleteRoutingMutation = useDeleteRoutingById();

  const handleDelete = () => {
    deleteRoutingMutation.mutate(routingId);
    setOpen(false);
  };

  return (
    <>
      <Button variant="tertiary" size="medium" data-full-width onClick={() => setOpen(true)}>
        <Dustbin variant="line" />
      </Button>
      <Modal size="small" open={open} onClose={() => setOpen(false)}>
        <ModalContent>Êtes-vous sûr de vouloir supprimer ce routage ?</ModalContent>
        <ModalActions side="right">
          <Button variant="secondary" onClick={() => setOpen(false)}>
            annuler
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            supprimer
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};

export default DeleteRoutingModalComponent;
